import React, { Component } from 'react';

export default class Errors extends Component {

	constructor(props) {
    super(props);
    this.state = {
			message: false,
			description: false
		}
	}

	compose() {
		console.log('error compose', this.props);
		let message = false;
		let description = false;

		if(this.props.error === 'NO-ACCESS') { // wrong credentials

			message = 'Sorry, your username and password do not match.';
			description = 'Check your username and password. You can use your e-mail address as user name.';

		} else if(this.props.error === 'NO-AUTH') { // session expired

			message = 'Please log in before you continue.';
			description = 'You are trying to access a page that requires you to log in or register.';

		} else if(this.props.error === 'NO-CONTENT') { // No content to upload

			message = 'No content to publish';
			description = 'You cannot publish a post without any content.';

		} else if(this.props.error === 'POST-REQ-NOK') {
			message = 'Your post did not publish.';
			description = 'Make sure you have locked location, added some content and chosen expiration time.'

		} else if(this.props.error === 'NO-FILE') {

			message = 'Errors in upload';
			description = 'Something wrong file file upload.'

		} else if(this.props.error === 'NO-CONN') {

			message = 'Cannot connect to server';
			description = 'Please try again later.'

		}

		return (
			<dl className="error">
				<dt>{ message }</dt>
				<dd>{ description }</dd>
			</dl>
		)
	}

	render() {
		console.log('ERRORS: ', this.props.error);

		if(this.props.error === false) return false;
		return ( this.compose() );
	}
}



// WEBPACK FOOTER //
// ./src/components/errors.jsx